import { useEffect, useState } from 'react'
import { getConsent, setConsent, type ConsentState } from './ConsentBanner'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Switch } from '@/components/ui/switch'
import { Button } from '@/components/ui/button'

export function CookiePreferences({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const [status, setStatus] = useState<ConsentState>('pending')

  useEffect(() => {
    if (isOpen) {
      setStatus(getConsent())
    }
  }, [isOpen])

  const handleSave = () => {
    setConsent(status)
    onClose()
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose() }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Cookie preferences</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">
          Manage how we use cookies. Essential cookies are always on to keep the site working.
        </p>

        <div className="flex items-center justify-between rounded-lg border p-4">
          <div className="pr-4">
            <p className="text-sm font-medium">Analytics cookies</p>
            <p className="text-xs text-muted-foreground">
              Help us understand how visitors use the site so we can improve it.
            </p>
          </div>
          <Switch
            checked={status === 'granted'}
            onCheckedChange={(checked) =>
              setStatus(checked ? 'granted' : 'denied')
            }
            aria-label="Toggle analytics cookies"
          />
        </div>

        <div className="flex justify-end gap-2 mt-2">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSave}>Save preferences</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
